import md5 from 'js-md5'
import { ElMessage } from 'element-plus'

/**
 * 获取一个32位随机字符串
 * @returns
 */
export function GetRandomString() {
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789'
  var maxPos = chars.length
  var pwd = ''
  for (var i = 0; i < 32; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}
/**
 * 随机生成GUID
 * @returns 
 */
export function CreateGuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010  
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01  
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}
/**
* 签名
* @param config 请求配置
* @param nonce 随机字符串
* @param timestamp 签名时间戳
* @param appSecret 应用密钥
* @param method 请求方式
*/
export function sign(config, nonce, timestamp, appSecret) {
  // 签名格式： timestamp + nonce + data(字典升序)+appSecret
  const ret = []
  if (config.params) {
    const pArray = []
    const data = config.params
    for (const it in data) {
      pArray.push(it)
    }
    // 字典升序
    const sArray = pArray.sort()
    for (const it of sArray) {
      let val = data[it]
      if (typeof val === 'object' && //
        (!(val instanceof Array) || (val.length > 0 && (typeof val[0] === 'object')))) {
        val = JSON.stringify(val)
      }
      ret.push(it + val)
    }
  } else {
    ret.push(JSON.stringify(config.data))
  }
  const signsrc = timestamp + nonce + ret.join('') + appSecret
  return md5(signsrc)
}

// 返回项目路径
export function getNormalPath(p) {
  if (p.length === 0 || !p || p == 'undefined') {
    return p
  };
  let res = p.replace('//', '/')
  if (res[res.length - 1] === '/') {
    return res.slice(0, res.length - 1)
  }
  return res;
}
/*
 * 当级联选项返回只有最后一个适合时调用
 * @param  list 数据列表
 * @param  id 后端返回的id
 **/
export function getParentsById(list, id) {
  for (let i in list) {
    if (list[i].Id == id) {
      //查询到就返回该数组对象的value
      return [list[i].Id]
    }
    if (list[i].Children) {
      let node = getParentsById(list[i].Children, id)
      if (node !== undefined) {
        //查询到把父节把父节点加到数组前面
        node.unshift(list[i].Id)
        return node
      }
    }
  }
}

// 验证是否为blob格式
export async function blobValidate(data) {
  try {
    const text = await data.text();
    JSON.parse(text);
    return false;
  } catch (error) {
    return true;
  }
}

// 取出上传成功后，接口返回的存储路径中的文件名
export async function getFileName(path) {
  let pos1 = path.lastIndexOf("/");
  let pos2 = path.lastIndexOf("\\");
  let pos = Math.max(pos1, pos2);
  if (pos < 0) {
    return path;
  } else {
    return path.substring(pos + 1);
  }
}

// 检测文件上传类型
export async function checkFileUpload(file, fileType, fileSize) {
  try {
    let isImg = false;
    if (fileType.length) {
      let fileExtension = "";
      if (file.name.lastIndexOf(".") > -1) {
        fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase();
      }
      isImg = fileType.some((type) => {
        if (file.type.indexOf(type) > -1) return true;
        if (fileExtension && fileExtension.indexOf(type) > -1) return true;
        return false;
      });
    } else {
      isImg = file.type.indexOf("image") > -1;
    }
    if (!isImg) {
      ElMessage.error(
        `文件格式不正确, 请上传${fileType.join("/")}格式文件!`
      );
      return false;
    }
    if (fileSize) {
      const isLt = file.size / 1024 / 1024 < fileSize;
      if (!isLt) {
        ElMessage.error(`上传文件大小不能超过 ${fileSize} MB!`);
        return false;
      }
    }
    return true;
  } catch (error) {
    return true;
  }
}
//第一个字母转小写
export function toLowerCaseFirstLetter(obj) {
  const newObj = {};
  Object.keys(obj).forEach(key => {
    newObj[key.charAt(0).toLowerCase() + key.slice(1)] = obj[key];
  });
  return newObj;
}